export default __webpack_public_path__ + "static/media/BAN.c47c721e.svg";